import RandomWord from '../data/RandomWord';

import { useEffect , useState } from 'react';

import DownArrow from '../img/down-arrow.png'
import Heart from '../img/like.png'
import HeartFill from '../img/like-fill.png'

import '../styles/Learn.css'

import {useFetch} from '../hooks/useFetch'

export default function Learn() {

    const [word , setWord] = useState('');
    const {data : wordInfo  } = useFetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`)
    /* set word */
     
    const [favState , setFavState ] = useState(false)
    useEffect(()=> {
    const rWord = RandomWord()
    /* error */
    if(localStorage.getItem("my_words") && 
        JSON.parse(localStorage.getItem("my_words")).includes(rWord)) {
                setFavState(true)
    }
    setWord(rWord)

    } , [])

    const checkFavs = (selectedWord) => {
        if(localStorage.getItem("my_words") && 
        JSON.parse(localStorage.getItem("my_words")).includes(selectedWord)) {
                setFavState(true)
        }          
    }
      
    

    const handleFav = () => {

       /*  localStorage.setItem("my_words", word) */
        if(!localStorage.getItem("my_words")) {
            const fav = [word]
            localStorage.setItem("my_words", JSON.stringify(fav));
          /*   alert('Added to Favourites') */

            setFavState(true)
        }else if(JSON.parse(localStorage.getItem("my_words")).length < 30){
            if(JSON.parse(localStorage.getItem("my_words")).includes(word)) {
               

                const storedFavs = JSON.parse(localStorage.getItem("my_words"));
                const filteredFavs = storedFavs.filter(w => w !== word)
                localStorage.setItem("my_words", JSON.stringify(filteredFavs));

                setFavState(false)

            }else {
                const fav = [...JSON.parse(localStorage.getItem("my_words")) , word ]
             localStorage.setItem("my_words", JSON.stringify(fav));
              setFavState(true)
            /*  alert('Added to Favourites') */

            
            }
            
        }else if(JSON.parse(localStorage.getItem("my_words")).length > 29) {
            alert('Max fav (30) reached')
        }
    }

    return (
        <div className='Learn'>
            <h1>Learn</h1>
            <div className='Learn-container'>
              {wordInfo && 
              <div className='Word'>
                    <div className='Word-heading'>
                        <h2>
                            {wordInfo[0].word}
                            {wordInfo[0].phonetic && <span> ({wordInfo[0].phonetic})</span> }
                        </h2>
                        <div className='fav' onClick={() => handleFav()}>
                            {favState ? <img src={HeartFill} alt=""/> : <img src={Heart} alt=""/>}
                            
                        </div>
                    </div>
                    {
                        wordInfo[0].meanings.map((meaning , index) => {
                           return (<div key={index} className='Word-info'>
                                <p className='parts-of-speech'>[{meaning.partOfSpeech}] </p> 
                                <p className='def'>{meaning.definitions[0].definition}</p>
                                {meaning.definitions[0].example && <p className='example'>"{meaning.definitions[0].example}"</p>}
                                                            
                            </div>)
                        })
                    }
                    <div className='next' onClick={() => {
                                setFavState(false)
                                let r = RandomWord()
                                setWord(r) 
                                checkFavs(r)

                            }
                           
                         }>
                        <img src={DownArrow} alt="" />
                    </div>
                </div>}
            </div>
        </div>
    )
}
